// extracted by mini-css-extract-plugin
export default {"SendToButton":"_SendToButton--BJZvf","Error":"_Error--HdXfZ","Icon":"_Icon--fVLkg"};